/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AgentEmail } from './AgentEmail';
import {
    AgentEmailFromJSON,
    AgentEmailFromJSONTyped,
    AgentEmailToJSON,
} from './AgentEmail';
import type { AgentName } from './AgentName';
import {
    AgentNameFromJSON,
    AgentNameFromJSONTyped,
    AgentNameToJSON,
} from './AgentName';
import type { AgentType } from './AgentType';
import {
    AgentTypeFromJSON,
    AgentTypeFromJSONTyped,
    AgentTypeToJSON,
} from './AgentType';
import type { CompletedAt1 } from './CompletedAt1';
import {
    CompletedAt1FromJSON,
    CompletedAt1FromJSONTyped,
    CompletedAt1ToJSON,
} from './CompletedAt1';
import type { ExpiresAt } from './ExpiresAt';
import {
    ExpiresAtFromJSON,
    ExpiresAtFromJSONTyped,
    ExpiresAtToJSON,
} from './ExpiresAt';
import type { Invoicing } from './Invoicing';
import {
    InvoicingFromJSON,
    InvoicingFromJSONTyped,
    InvoicingToJSON,
} from './Invoicing';
import type { StartedAt } from './StartedAt';
import {
    StartedAtFromJSON,
    StartedAtFromJSONTyped,
    StartedAtToJSON,
} from './StartedAt';
import type { VisitType1 } from './VisitType1';
import {
    VisitType1FromJSON,
    VisitType1FromJSONTyped,
    VisitType1ToJSON,
} from './VisitType1';

/**
 * Visit form summary scoped to a listing.
 * @export
 * @interface ListingVisitFormItem
 */
export interface ListingVisitFormItem {
    /**
     * Visit form UUID
     * @type {string}
     * @memberof ListingVisitFormItem
     */
    id: string;
    /**
     * 
     * @type {VisitType1}
     * @memberof ListingVisitFormItem
     */
    visitType?: VisitType1;
    /**
     * 
     * @type {AgentName}
     * @memberof ListingVisitFormItem
     */
    agentName?: AgentName;
    /**
     * 
     * @type {AgentEmail}
     * @memberof ListingVisitFormItem
     */
    agentEmail?: AgentEmail;
    /**
     * 
     * @type {AgentType}
     * @memberof ListingVisitFormItem
     */
    agentType?: AgentType;
    /**
     * 
     * @type {Invoicing}
     * @memberof ListingVisitFormItem
     */
    invoicing?: Invoicing;
    /**
     * 
     * @type {StartedAt}
     * @memberof ListingVisitFormItem
     */
    startedAt?: StartedAt;
    /**
     * 
     * @type {CompletedAt1}
     * @memberof ListingVisitFormItem
     */
    completedAt?: CompletedAt1;
    /**
     * 
     * @type {ExpiresAt}
     * @memberof ListingVisitFormItem
     */
    expiresAt?: ExpiresAt;
    /**
     * Visit form status
     * @type {string}
     * @memberof ListingVisitFormItem
     */
    status: string;
}

/**
 * Check if a given object implements the ListingVisitFormItem interface.
 */
export function instanceOfListingVisitFormItem(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "status" in value;

    return isInstance;
}

export function ListingVisitFormItemFromJSON(json: any): ListingVisitFormItem {
    return ListingVisitFormItemFromJSONTyped(json, false);
}

export function ListingVisitFormItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListingVisitFormItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'visitType': !exists(json, 'visit_type') ? undefined : VisitType1FromJSON(json['visit_type']),
        'agentName': !exists(json, 'agent_name') ? undefined : AgentNameFromJSON(json['agent_name']),
        'agentEmail': !exists(json, 'agent_email') ? undefined : AgentEmailFromJSON(json['agent_email']),
        'agentType': !exists(json, 'agent_type') ? undefined : AgentTypeFromJSON(json['agent_type']),
        'invoicing': !exists(json, 'invoicing') ? undefined : InvoicingFromJSON(json['invoicing']),
        'startedAt': !exists(json, 'started_at') ? undefined : StartedAtFromJSON(json['started_at']),
        'completedAt': !exists(json, 'completed_at') ? undefined : CompletedAt1FromJSON(json['completed_at']),
        'expiresAt': !exists(json, 'expires_at') ? undefined : ExpiresAtFromJSON(json['expires_at']),
        'status': json['status'],
    };
}

export function ListingVisitFormItemToJSON(value?: ListingVisitFormItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'visit_type': VisitType1ToJSON(value.visitType),
        'agent_name': AgentNameToJSON(value.agentName),
        'agent_email': AgentEmailToJSON(value.agentEmail),
        'agent_type': AgentTypeToJSON(value.agentType),
        'invoicing': InvoicingToJSON(value.invoicing),
        'started_at': StartedAtToJSON(value.startedAt),
        'completed_at': CompletedAt1ToJSON(value.completedAt),
        'expires_at': ExpiresAtToJSON(value.expiresAt),
        'status': value.status,
    };
}

